import { v4 as uuid } from "uuid";
import { z } from "zod";
import { EmissionFactorScope } from "../../entities/emissionFactor";
import { EcoLabel, EnvironmentalCategory, EnvironmentalMetricType, EnvironmentalSubCategory, EnvironmentalTargetType, WasteDisposalDestination } from "../../entities/environmentalCommitment";
import { EnvironmentalTargetDirection, EnvironmentalTargetMeasure, EnvironmentalTargetMeasuredBy, EnvironmentalTargetMethod } from "../../entities/environmentalTarget";
import { ProjectCommmitmentGenerationSource } from "../project/enums";
export const projectEnvironmentalTargetLineItemSchema = z.object({
    /** `BaselineToTarget` only: which way the change goes (≤ cut, ≥ increase). */
    baselineFactor: z.enum(EnvironmentalTargetDirection).optional(),
    /** `BaselineToTarget` only: the project's reference figure, in the target's
     *  unit. The scored threshold is derived from it, the factor and the %. */
    baselineValue: z.number().optional(),
    category: z.enum(EnvironmentalCategory).optional(),
    created: z.date(),
    description: z.string(),
    /** `EcoLabelShare` only. Absent/empty = any approved label counts. */
    ecoLabels: z.array(z.enum(EcoLabel)).optional(),
    /** Absent = every scope. Only meaningful when `measure` is `Emissions`. */
    emissionScopes: z.array(z.enum(EmissionFactorScope)).optional(),
    generationSource: z.enum(ProjectCommmitmentGenerationSource).optional(),
    id: z.string(),
    measure: z.enum(EnvironmentalTargetMeasure),
    measuredBy: z.enum(EnvironmentalTargetMeasuredBy),
    metricType: z.enum(EnvironmentalMetricType).optional(),
    projectId: z.string(),
    /** `SourceShare` only: the water categories that count toward the share. */
    shareCategories: z.array(z.enum(EnvironmentalCategory)).optional(),
    sourceFrameworkId: z.string().optional(),
    sourceFrameworkTargetId: z.string().optional(),
    subCategory: z.enum(EnvironmentalSubCategory).optional(),
    targetMethod: z.enum(EnvironmentalTargetMethod),
    /** Absent = every type. Only an emissions target may leave it out. */
    targetType: z.enum(EnvironmentalTargetType).optional(),
    targetValue: z.number(),
    /** Reported Quantity Waste only. Absent/empty = all destinations. */
    wasteDisposalDestinations: z
        .array(z.enum(WasteDisposalDestination))
        .optional(),
    /** Reported Quantity Waste only. Absent = Any. */
    wasteHazardous: z.boolean().optional()
});
export const createDefaultProjectEnvironmentalTargetLineItem = (projectId) => ({
    created: new Date(),
    description: "",
    generationSource: ProjectCommmitmentGenerationSource.Custom,
    id: uuid(),
    measure: EnvironmentalTargetMeasure.NativeQuantity,
    measuredBy: EnvironmentalTargetMeasuredBy.ShareOfQuantities,
    projectId,
    targetMethod: EnvironmentalTargetMethod.Percentage,
    targetType: EnvironmentalTargetType.Waste,
    targetValue: 0
});
